import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import './Waitlist.scss';
const Waitlist = () => {
  const { width } = useWindowSize();
  function handleredirect(link) {
    window.open(link, '_blank');
  }

  return (
    <div className='waitlist_wrapper'>
      <div className='waitlist_wrapper__each' onClick={() => handleredirect('https://ridiculouslyunfair.mercle.ai/')}>
        <img src={require('./red.png')} />
      </div>
      <div className='waitlist_wrapper__each' onClick={() => handleredirect('https://lessunfair.mercle.ai/')}>
        <img src={require('./blue.png')} />
      </div>
    </div>
  );
};

export default Waitlist;
